import type React from "react";
import { Skeleton as ShadcnSkeleton } from "src/shadcn/components/skeleton";

const Skeleton = (props: React.ComponentProps<typeof ShadcnSkeleton>) => (
  <ShadcnSkeleton {...props} />
);

export { Skeleton };
